import {QueryFunctionContext} from 'react-query';
import request from 'services/axios';

export const getFarmSaleTypes = async (ctx: QueryFunctionContext) => {
  const {data}: {data: IGetSalesType[]} = await request.get(
    `/api/v2/market/sale-type?app=farm&cultivation_guid=${ctx.queryKey[1]}`,
  );
  return data;
};
